module.exports = __webpack_public_path__ + "img/check.86e31366.svg";